import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";

//container component setting a color class from data
class ColorContainer extends BaseComponent {
    render() {
        const dataProps = webui.getUtils().extractComponentProps(this.props, {
            additionalProps: ["value", "extraClasses", "colorPrefix"],
            propsDefaults: {
                value: "1",
                colorPrefix: "",
                extraClasses: ""
            }
        });
        return (
            <div className={`${dataProps.colorPrefix}${dataProps.value} ${dataProps.extraClasses}`}>
                {this.resolveChildren()}
            </div>
        );
    }
}

export default webui.connectComponent()(ColorContainer);
